import "./../css/main.css";
import "./components/header";
// import "./components/hero";
import "./components/tito";
import "./utils/hubspot-forms"
import "../../../node_modules/@github/time-elements";
import "../../../node_modules/lite-youtube-embed/src/lite-yt-embed.js"

import lazyLoadImages from "./utils/lazy-loading/lazy-loading";
import { mediaQueries } from "./utils/browser";

if (mediaQueries.papaBear() && !mediaQueries.prefersReducedMotion()) {
  import("./confettis/confettis")
    .then(confettis => {
      confettis.default.forEach(confetti => confetti.start());

      /* Make sure the confettis still works when the body height changes */
      const body = document.querySelector("body");
      body.addEventListener("lazy-image-loaded", () => {
        confettis.default.forEach(confetti => confetti.calculate());
      });
    })
    .catch(err => {
      console.log(err);
    });
}

lazyLoadImages();
